<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FetcherProductShow",
  props: {
    globalHashid: {
      required: true,
      type: String,
    },
  },
  created() {
    this.fetchCurrentUser();
    this.fetchProductData(this.globalHashid);
  },
  methods: {
    ...mapActions({
      fetchProductData: "productShow/fetchProductData",
      fetchCurrentUser: "currentUser/fetchCurrentUser",
    }),
  },
};
</script>
